import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../../BaseConfig';
import GeneralButtonWithText from '../../helpers/GeneralButtonWithText';
import { UIProperties } from '../../UIProperties';
import { constants } from '../../../misc/constants';
import { getWindowVariable, reactToSmeDebug } from '../../../misc/tools';
import GameManager from '../../../cvp-webgames-core/GameManager';
import SingleGraphUI, { SingleGraphUIConfig } from './SingleGraphUI';
import MonitorOverlay from './MonitorOverlay';
import { SideMenuUIConfig } from './SideMenu';
import { globals } from '../../../misc/globals';
import { Window508Type } from '../../../scenarios/DaarcBaseScenario';
var setInt: any = null;
var update = false;
var hasHrFlatline = false;
var hasSa02Flatline = false;
var hasEtc02Flatline = false;
var sa02Percentage = -404;
var originalBpNumerator: any = undefined;
var originalBpDenominator: any = undefined;
var isBloodPressureIncreasing = true;
var originalHr: any = undefined;
var isHeartRateIncreasing = true;
var bpMultiplier = 1;
var hrMultiplier = 1;
var sa02Multiplier = 1;
var initialHr = 0;
var maxHr = 0;
var isStoppingHeart = false;
var maxTimeInSeconds = 0;
var countDown = 0;
var alreadyStartedBlip = false;
var isDebriefOpened = false;
var resetSa02 = 0;
export const getCorrectControls = (val: number, dataItems: {min: number, max: number, graphData?: SingleGraphUIConfig, blipTime?: number, pitch?: number}[]) => {
	for(var indx = 0; indx < dataItems.length; indx++) {
		var dataItem = dataItems[indx];
		if(dataItem.min <= val && dataItem.max >= val) {
			return dataItem;
		}
	}
}

export const mergeGraphData = (arr: any[]) => {
	var result: any = [];

	for(var indx = 0; indx < arr.length; indx++) {
		result.push(arr[indx].graphData);
	}
	return result;
}
var resetEtc02 = false;
const MonitorUI = (props: UIProperties<MonitorUIConfig>) => {
	const [showMonitorUI, setShowMonitorUI] = useState(false);
	
	if(sa02Percentage === -404) {
		sa02Percentage = props.parameters.sa02;
		maxTimeInSeconds = props.parameters.apneaTimeInSeconds;
		countDown = props.parameters.apneaTimeInSeconds;
	}

	(window as any).onMonitorButtonClicked = () => {
		setShowMonitorUI(true);
		props.parameters.gameManager.customData.scenario.update508Window(Window508Type.Monitor);
	}

	const updateValues = () => {
		props.parameters.onDataUpdated({
			bloodPressureNumerator: props.parameters.bloodPressureNumerator,
			bloodPressureDenominator: props.parameters.bloodPressureDenominator,
			bloodPressureMinNumerator: props.parameters.bloodPressureMinNumerator,
			bloodPressureMinDenominator: props.parameters.bloodPressureMinDenominator,
			etc02Val: props.parameters.etc02,
			sa02Value: sa02Percentage * sa02Multiplier,
			heartRate: props.parameters.heartRate,
			respirationRate: props.parameters.respirationRate,
			hasHrFlatline: hasHrFlatline,
			hasSa02Flatline: hasSa02Flatline,
			hasEtc02Flatline: props.parameters.etc02 === 0,
			showETC02: props.parameters.showETC02
		});
		// (window as any)['ekgcontrols'] = {
		// 	heartrateControls: heartrateControls,
		// 	respirationDataControls: respirationDataControls
		// };
	}
	const updateBp = (apneaPercentage: number) => {
		var bpPercentage = apneaPercentage * bpMultiplier;
		var deltaBpNumerator = 0;
		var newBpNumerator = 0;
		var deltaBpDenominator = 0;
		var newBpDenominator = 0;

		isBloodPressureIncreasing = bpPercentage > 0.5;
		if(isBloodPressureIncreasing) {
			var bpIncreasePercentage = (1 - bpPercentage) ;
			if(bpIncreasePercentage > 1) {
				bpIncreasePercentage = 1;
			}
			deltaBpNumerator = Math.abs(props.parameters.bloodPressureMaxNumerator - originalBpNumerator);
			newBpNumerator = props.parameters.bloodPressureMinNumerator + (deltaBpNumerator + (deltaBpNumerator * bpIncreasePercentage));
			deltaBpDenominator = Math.abs(props.parameters.bloodPressureMaxDenominator - originalBpDenominator);
			newBpDenominator = props.parameters.bloodPressureMinDenominator + deltaBpDenominator + (deltaBpDenominator * bpIncreasePercentage);

			if(newBpDenominator > props.parameters.bloodPressureMaxDenominator) {
				newBpDenominator = props.parameters.bloodPressureMaxDenominator;
			}
			if(newBpNumerator > props.parameters.bloodPressureMaxNumerator) {
				newBpNumerator = props.parameters.bloodPressureMaxNumerator;
			}
		} else {
			var bpDecreasePercentage = (bpPercentage * 2) ;
			if(bpDecreasePercentage > 1) {
				bpDecreasePercentage = 1;
			}
			deltaBpNumerator = Math.abs(props.parameters.bloodPressureMinNumerator - props.parameters.bloodPressureMaxNumerator);
			newBpNumerator = props.parameters.bloodPressureMinNumerator + (deltaBpNumerator * bpDecreasePercentage);
			deltaBpDenominator = Math.abs(props.parameters.bloodPressureMinDenominator - props.parameters.bloodPressureMaxDenominator);
			newBpDenominator = props.parameters.bloodPressureMinDenominator + (deltaBpDenominator * bpDecreasePercentage);
			if(newBpDenominator < props.parameters.bloodPressureMinDenominator) {
				newBpDenominator = props.parameters.bloodPressureMinDenominator;
			}
			if(newBpNumerator < props.parameters.bloodPressureMinNumerator) {
				newBpNumerator = props.parameters.bloodPressureMinNumerator;
			}
		}

		props.parameters.bloodPressureNumerator = newBpNumerator;
		props.parameters.bloodPressureDenominator = newBpDenominator;
	}

	const updateHr = (apneaPercentage: number) => {
		// var hrPercentage = apneaPercentage * hrMultiplier;
		// var deltaHr = 0;
		var newHr = 0;

		isHeartRateIncreasing = sa02Percentage > 80;
		const maxIncrease = 30;
		const maxHr = initialHr + maxIncrease;

		if(isHeartRateIncreasing) {
			//20 is 100% because we are only incrasing as long as sa02 is above 80....100-80=20
			var increasePercentageNormalized = (100 - sa02Percentage) / 20;

			newHr = initialHr + (maxIncrease * increasePercentageNormalized);
		} else {
			//30 is 100% because we are only decreasing as long as sa02 is above 50....80-50=30
			var decrasePercentageNormalized = (80 - sa02Percentage) / 30;
			var maxDecrease = 50;

			newHr = maxHr - (maxDecrease * decrasePercentageNormalized);

			if(newHr < 0) {
				newHr = 0;
			}

			if(!isStoppingHeart && sa02Percentage === 0) {
				isStoppingHeart = true;
				setTimeout(() => {
					props.parameters.heartRate = 0;
					hasHrFlatline = true;
				}, 500);
			}
		}

		// isHeartRateIncreasing = hrPercentage > 0.5;
		// if(isHeartRateIncreasing) {
		// 	var hrIncreasePercentage = ((1 - hrPercentage) * 2);
		// 	if(hrIncreasePercentage > 1) {
		// 		hrIncreasePercentage = 1;
		// 	}
		// 	if(hrIncreasePercentage < 0) {
		// 		hrIncreasePercentage = 0;
		// 	}
		// 	deltaHr = Math.abs(props.parameters.heartRateMax - originalHr);
		// 	newHr = originalHr + (deltaHr * hrIncreasePercentage);

		// 	if(newHr > props.parameters.heartRateMax) {
		// 		newHr = props.parameters.heartRateMax;
		// 	}
		// } else {
		// 	var hrDecreasePercentage = (hrPercentage * 2) ;
		// 	if(hrDecreasePercentage > 1) {
		// 		hrDecreasePercentage = 1;
		// 	}
		// 	newHr = props.parameters.heartRateMax * hrDecreasePercentage;
		// 	if(newHr > props.parameters.heartRateMax) {
		// 		newHr = props.parameters.heartRateMax;
		// 	}
		// 	if(newHr < 0) {
		// 		newHr = 0;
		// 	}
		// }

		if(!hasHrFlatline) {
			props.parameters.heartRate = newHr;
		}
	}

	const setupTimeout = () => {
		if(setInt) {
			clearInterval(setInt);
			hasEtc02Flatline = false;
			hasHrFlatline = false;
			hasSa02Flatline = false;
			setInt = null;
		}
		
		var maxInductionTime = props.parameters.inductionTimeInSeconds;
		var maxRR = 35;
		var maxEtc02 = 35;
		initialHr = props.parameters.heartRate;
		var etco2Timeout: any = null;
		setInt = setInterval(() => {
			if(props.parameters.isIdle) {
				return;
			}
			if(resetEtc02 && !etco2Timeout) {
				// var totalCalls = 220 * 5;
				// var rrPercentage = 1 - (props.parameters.respirationRate / maxRR);
				// var rrMaxIncrease = rrPercentage * props.parameters.respirationRate;
				// var rrStep = rrMaxIncrease / totalCalls; 

				// var etc02Percentage = 1 - (props.parameters.etc02 / maxEtc02);
				// var etc02MaxIncrease = etc02Percentage * props.parameters.etc02;
				// var etc02Step = etc02MaxIncrease / totalCalls; 

				var rrStep = 0.1; 
				var etc02Step = 0.1; 
				var sa02Step = 0.1; 

				var currentRrVal = props.parameters.respirationRate;
				var currentEtc02Val = props.parameters.etc02;
				var currentSa02Val = props.parameters.sa02;
				var maxSa02 = resetSa02;
				etco2Timeout = setInterval(() => {
					if(props.parameters.respirationRate >= maxRR) {
						props.parameters.respirationRate = maxRR;
					} else {
						currentRrVal += rrStep;
					}

					if(props.parameters.etc02 >= maxEtc02) {
						props.parameters.etc02 = maxEtc02;
					} else {
						currentEtc02Val += etc02Step;
					}

					if(props.parameters.sa02 >= maxSa02) {
						props.parameters.sa02 = maxSa02;
					} else {
						currentSa02Val += sa02Step;
					}

					props.parameters.respirationRate = currentRrVal;
					props.parameters.etc02 = currentEtc02Val;
					props.parameters.sa02 = currentSa02Val;

					props.parameters.respirationRate = Math.round(props.parameters.respirationRate);
					props.parameters.etc02 = Math.round(props.parameters.etc02);
					props.parameters.sa02 = Math.round(props.parameters.sa02);
					sa02Percentage = props.parameters.sa02;
					
					if(props.parameters.respirationRate === maxRR && props.parameters.etc02 === maxEtc02 && props.parameters.sa02 === resetSa02) {
						clearInterval(etco2Timeout);
						etco2Timeout = null;
						resetEtc02 = false;
					}
				}, 0);
			}
			if(props.parameters.inductionTimeInSeconds >= 0) {
				props.parameters.inductionTimeInSeconds--;
				var deltaPercentage = props.parameters.inductionTimeInSeconds / maxInductionTime;

				if(deltaPercentage < 0) {
					deltaPercentage = 0;
				}

				props.parameters.respirationRate = Math.round(maxRR * deltaPercentage);
				props.parameters.etc02 = Math.round(maxEtc02 * deltaPercentage);
			} else if(!props.parameters.stopSa02) {
				countDown--;
				var percentageNormalized = (countDown / maxTimeInSeconds) * sa02Multiplier;
				var percentage = percentageNormalized;
				// var percentage = percentageNormalized * 100;
				if(percentage < 0) {
					percentage = 0;
				}
				sa02Percentage = Math.floor(props.parameters.sa02 * percentage);

				if(!originalBpDenominator && !originalBpNumerator) {
					originalBpNumerator = props.parameters.bloodPressureNumerator;
					originalBpDenominator = props.parameters.bloodPressureDenominator;
				}

				if(!originalHr) {
					originalHr = props.parameters.heartRate;
				}

				updateBp(percentageNormalized);
				updateHr(percentageNormalized);
				
				updateValues();
			}

			if(sa02Percentage <= 50 && !hasSa02Flatline) {
				hasSa02Flatline = true;
				// props.parameters.heartRate = 0;
				// props.parameters.bloodPressureDenominator = props.parameters.bloodPressureMinDenominator;
				// props.parameters.bloodPressureNumerator = props.parameters.bloodPressureMinNumerator;
				// props.parameters.respirationRate = 0;
				// sa02Percentage = 0;
				updateValues();
			}
			update = !update;
		}, 1000);
	}

	const reactToDebug = () => {
		if(getWindowVariable(constants.smeDebug.variables.vitalsBpNumerator)) {
			var testVitalsBpNumerator = getWindowVariable(constants.smeDebug.variables.vitalsBpNumerator);
			var testVitalsBpDenominator = getWindowVariable(constants.smeDebug.variables.vitalsBpDenominator);
			var testVitalsMinBpNumerator = getWindowVariable(constants.smeDebug.variables.vitalsMinBpNumerator);
			var testVitalsMinBpDenominator = getWindowVariable(constants.smeDebug.variables.vitalsMinBpDenominator);
			var testVitalsMaxBpNumerator = getWindowVariable(constants.smeDebug.variables.vitalsMaxBpNumerator);
			var testVitalsMaxBpDenominator = getWindowVariable(constants.smeDebug.variables.vitalsMaxBpDenominator);
			var testVitalsBpMultiplier = getWindowVariable(constants.smeDebug.variables.vitalsBpMultiplier);

			var testVitalsHr = getWindowVariable(constants.smeDebug.variables.vitalsHr);
			var testVitalsHrMax = getWindowVariable(constants.smeDebug.variables.vitalsMaxHr);
			var testVitalsHrMultiplier = getWindowVariable(constants.smeDebug.variables.vitalsHrMultiplier);
			var testVitalsEtc02 = getWindowVariable(constants.smeDebug.variables.vitalsEtc02);
			var testVitalsRr = getWindowVariable(constants.smeDebug.variables.vitalsRR);
			var testSa02 = getWindowVariable(constants.smeDebug.variables.vitalsSa02);
			var testVitalsSa02Multiplier = getWindowVariable(constants.smeDebug.variables.vitalsSa02Multiplier);
			var testInductionTime = getWindowVariable(constants.smeDebug.variables.apneaInductionTime);
			var testapneaTime = getWindowVariable(constants.smeDebug.variables.apneaApneaTime);
				
			props.parameters.inductionTimeInSeconds = testInductionTime;
			props.parameters.apneaTimeInSeconds = testapneaTime;

			props.parameters.bloodPressureNumerator = testVitalsBpNumerator;
			props.parameters.bloodPressureDenominator = testVitalsBpDenominator;
			props.parameters.bloodPressureMinNumerator = testVitalsMinBpNumerator;
			props.parameters.bloodPressureMinDenominator = testVitalsMinBpDenominator;
			props.parameters.bloodPressureMaxNumerator = testVitalsMaxBpNumerator;
			props.parameters.bloodPressureMaxDenominator = testVitalsMaxBpDenominator;

			props.parameters.heartRate = testVitalsHr;
			props.parameters.heartRateMax = testVitalsHrMax;
			props.parameters.etc02 = testVitalsEtc02;
			props.parameters.respirationRate = testVitalsRr;
			sa02Percentage = testSa02;
			props.parameters.sa02 = testSa02;
			originalBpNumerator = props.parameters.bloodPressureNumerator;
			originalBpDenominator = props.parameters.bloodPressureDenominator;
			bpMultiplier = testVitalsBpMultiplier;
			hrMultiplier = testVitalsHrMultiplier;
			sa02Multiplier = testVitalsSa02Multiplier;
			setupTimeout();
			updateValues();
		}
	};

	useEffect(() => {
		(window as any).monitorRefresh = (sideMenuParams: SideMenuUIConfig) => {

			if(typeof sideMenuParams.resetEtc02 !== 'undefined') {
				resetEtc02 = sideMenuParams.resetEtc02;
				if(resetEtc02) {
					hasEtc02Flatline = false;
				}
				resetSa02 = sideMenuParams.sa02;
			} else if(typeof sideMenuParams.sa02 !== 'undefined') {
				props.parameters.sa02 = sideMenuParams.sa02;
				sa02Percentage = props.parameters.sa02;
			}

			if(typeof sideMenuParams.notBreathing !== 'undefined') {
				props.parameters.etc02 = 0;
				props.parameters.respirationRate = 0;
				hasEtc02Flatline = true;
			}

			if(typeof sideMenuParams.showETC02 !== 'undefined') {
				props.parameters.showETC02 = sideMenuParams.showETC02;
			}

			if(typeof sideMenuParams.stopSa02 !== 'undefined') {
				props.parameters.stopSa02 = sideMenuParams.stopSa02;
			}

			if(typeof sideMenuParams.isApneaTimerIdle !== 'undefined') {
				props.parameters.isIdle = sideMenuParams.isApneaTimerIdle;
			}

			if(typeof sideMenuParams.apneaTimeInSeconds !== 'undefined') {
				props.parameters.apneaTimeInSeconds = sideMenuParams.apneaTimeInSeconds;
				maxTimeInSeconds = props.parameters.apneaTimeInSeconds;
				countDown = props.parameters.apneaTimeInSeconds;
			}
		}

		reactToDebug();
		reactToSmeDebug('MonitorUI', reactToDebug);

		setupTimeout();
		
		const playBlip = () => {

			var isFlatLine = hasHrFlatline;
			var percentage = props.parameters.heartRate / 100;
	
			//calculate time...
			// var blipMaxPercentageTime = 300;
			// var blipMinPercentageTime = 1000;
			// var timeDelta = Math.abs(blipMaxPercentageTime-blipMinPercentageTime);
			// var normalizedTime = timeDelta - (timeDelta * percentage);
			// const time = normalizedTime + Math.min(blipMinPercentageTime, blipMaxPercentageTime);
			var controls = getCorrectControls(props.parameters.heartRate, constants.monitor.heartRateDataControls);
			var respirationsControls = getCorrectControls(props.parameters.heartRate, constants.monitor.respirationDataControls);
			var pitchControl = getCorrectControls(sa02Percentage, constants.monitor.pitch);
			const time = controls.blipTime ?? 0;
			//calculate pitch...
			// var maxPitch = 0;
			// var minPitch = 100;
			// var pitchDelta = Math.abs(maxPitch-minPitch);
			// var normalizedPitch = pitchDelta - (pitchDelta * percentage);
			// var pitch = -1 * (normalizedPitch + Math.min(minPitch, maxPitch));
			
			var pitch = typeof(pitchControl.pitch) !== 'undefined' ? pitchControl.pitch : constants.monitor.defaultPitch;
			props.parameters.gameManager.SoundManager.playSound({
				src: isFlatLine ? './assets/audio/pulse/FlatLine.wav' : './assets/audio/pulse/Blip.wav',
				onEnded: isFlatLine ? undefined : () => {
					if(isDebriefOpened) {
						return;
					}
					setTimeout(() => {
						playBlip();
					}, time);
				},
				loop: isFlatLine ? true : false,
				oneShot: isFlatLine ? false : true,
				playsInline: true,
				pitch: isFlatLine ? undefined : pitch,
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 0.25
			});
		}

		(window as any).onSbarClosed = () => {
			if(!alreadyStartedBlip) {
				playBlip();
				alreadyStartedBlip = true;
			}
		}

		(window as any).onDebriefOpened = () => {
			isDebriefOpened = true;
		}

		const getCorrectInterval = () => {
			return 60 * 1000 / (100 * 58);
		}
		var interval = getCorrectInterval();

		const loop = () => {  
			// heartrateControls = getCorrectControlsIndex(props.parameters.heartRate, constants.monitor.heartRateDataControls)
			// respirationDataControls = getCorrectControlsIndex(sa02Percentage, constants.monitor.respirationDataControls)
			updateValues();
			setTimeout(loop, interval)
		}
		loop();
	}, [])
	return (
		<div className='monitor-ui modal-disable-select' style={{
			position: 'absolute',
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			<div className='modal-bg monitor-container' style={{
				position: 'absolute',
				left: '0',
				top: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'all',
				// display: showMonitorUI ? 'block' : 'none'
				visibility: showMonitorUI ? 'visible' : 'hidden',
				zIndex: 1000
			}}>
				<div style={{
					position: 'absolute',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '940px',
					height: '540px',
					backgroundColor: 'black',
					borderRadius: '25px'
				}} tabIndex={0} id='monitor-ui-root' aria-label='Monitor' >
					<div style={{
						position: 'relative',
						top: '0',
						left: '0',
						width: '100%',
						height: '100px'
					}}>
						<div style={{
							position: 'absolute',
							top: '0',
							left: '0',
							width: '50%',
							height: '100px'
						}}>
							<div style={{
								width: '100%',
								height: '100%',
								borderBottom: '2px white solid',
								borderRight: '2px white solid'
							}}>
							</div>
						</div>
						<div style={{
							position: 'absolute',
							top: '0',
							right: '0',
							width: '50%',
							height: '100px'
						}}>
							<div style={{
								width: '100%',
								height: '100%',
								borderBottom: '2px white solid'
							}}>
								
							</div>
						</div>
					</div>
					
					<main>
						<div className="graph" style={{
							borderBottom: '2px white solid',
							position: 'relative'
						}}>
							<div className="graph-canvas">
								<div style={{
									width: '790px',
									height: '105px',
									borderRight: '2px white solid',
									pointerEvents: 'none',
									overflow: 'hidden',
									position: 'relative',
    								top: '1px'
								}}>
									<div style={{
											width: '789px',
											height: '103px',
											position: 'absolute',
											top: '0',
											left: '0'
										}}>
										<SingleGraphUI parameters={{
											graphs: mergeGraphData(constants.monitor.heartRateDataControls),
											initData: constants.monitor.heartRateData,
											onGetGraph: () => {
												if(props.parameters.heartRate <= 0) {
													return constants.monitor.heartRateDataControls[0].graphData;
												}

												return !constants.monitor.debug ? getCorrectControls(props.parameters.heartRate, constants.monitor.heartRateDataControls).graphData : constants.monitor.heartRateDataControls[0].graphData;
											}
										}}></SingleGraphUI>
									</div>
									{/* <canvas style={{
										position: 'relative',
										top: '12px'
									}} id="heartbeat-chart"   height="30"></canvas> */}
								</div>
							</div>
						</div>
						<div className="graph"  style={{
							borderBottom: '2px white solid',
							position: 'relative'
						}}>
							<div style={{
									width: '790px',
									height: '105px',
									borderRight: '2px white solid',
									pointerEvents: 'none',
									overflow: 'hidden',
									position: 'relative',
    								top: '1px'
								}}>
									<div style={{
											width: '789px',
											height: '103px',
											position: 'absolute',
											top: '0',
											left: '0'
										}}>
										<SingleGraphUI parameters={{
											graphs: mergeGraphData(constants.monitor.respirationDataControls),
											initData: constants.monitor.respirationData,
											onGetGraph: () => {
												if(hasSa02Flatline) {
													return constants.monitor.respirationDataControls[0].graphData;
												}
												return !constants.monitor.debug ? getCorrectControls(props.parameters.heartRate, constants.monitor.respirationDataControls).graphData : constants.monitor.respirationDataControls[0].graphData;
											}
										}}></SingleGraphUI>
									</div>
									{/* <canvas style={{
										position: 'relative',
										top: '12px'
									}} id="heartbeat-chart"   height="30"></canvas> */}
								</div>
						</div>
						<div style={{
							position: 'relative'
						}} className="graph">
							<div style={{
								width: '790px',
								height: '105px',
								borderRight: '2px white solid',
								borderBottom: '2px white solid',
								pointerEvents: 'none',
								overflow: 'hidden',
								position: 'relative',
								top: '1px'
							}}>
								<div style={{
									width: '789px',
									height: '103px',
									position: 'absolute',
									top: '0',
									left: '0'
								}}>
									{/* <canvas style={{
										display: 'none',
										position: 'relative',
										top: '12px'
									}} id="spo2-chart" height="30"></canvas>
									{props.parameters.onRenderETC02()} */}
									<SingleGraphUI parameters={{
										graphs: mergeGraphData(constants.monitor.etc02DataInMonitorUIDataControls),
										initData: constants.monitor.etc02DataInMonitorUIData,
										onGetGraph: () => {
											if(hasEtc02Flatline || constants.monitor.debug) {
												return constants.monitor.etc02DataInMonitorUIDataControls[0].graphData;
											}
											return !constants.monitor.debug ? getCorrectControls(props.parameters.etc02, constants.monitor.etc02DataInMonitorUIDataControls).graphData : constants.monitor.etc02DataInMonitorUIDataControls[0].graphData;
										},
										onUpdateVisibility: () => {
											return props.parameters.showETC02;
										}
									}}></SingleGraphUI>
								</div>
								
							</div>
						</div>
					</main>
					
					<footer style={{
						display: 'none'
					}}>
						<div className="buttons">
							<button className="button">Record</button>
							<button className="button">Close</button>
						</div>
						<div className="stats">
							<div>
							Blood Pressure: --/--
							</div>
							<div>
							Temperature: 27.35 ºC
							</div>
						</div>
					</footer>
				</div>
			</div>
			{showMonitorUI ? (
				<div>
					<MonitorOverlay hrColor={constants.monitor.heartRateData.lineColor}
								sa02Color={constants.monitor.respirationData.lineColor}
								etc02Color={constants.monitor.etc02DataInMonitorUIData.lineColor}></MonitorOverlay>
					<GeneralButtonWithText parameters= {{
						text: 'Close',
						top: '710px',
						left: '880px',
						width: '140px',
						isDisabled: false,
						ariaLbl: 'Close',
						id:"monitor-ui-close-bttn",
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customMainStyle: {
							zIndex: 1000
						},
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							setShowMonitorUI(false);
							props.parameters.gameManager.customData.scenario.update508Window(Window508Type.Main);
						}
					}}/>
				</div>
			) : (null)}
		</div>
	);

};

export interface MonitorUIConfig extends BaseConfig{
	bloodPressureNumerator: number;
	bloodPressureDenominator: number;
	bloodPressureMinNumerator: number;
	bloodPressureMinDenominator: number;
	bloodPressureMaxNumerator: number;
	bloodPressureMaxDenominator: number;
	sa02: number;
	stopSa02?: boolean;
	heartRate: number;
	heartRateMax: number;
	respirationRate: number;
	etc02: number;
	inductionTimeInSeconds: number;
	apneaTimeInSeconds: number;
	isIdle: boolean;
	onRenderETC02: () => void;
	showETC02: boolean;
	gameManager: GameManager;
	onDataUpdated: (newData: MonitorUIData) => void;
}

export interface MonitorUIData {
	sa02Value: number;
	etc02Val: number;
	heartRate: number;
	respirationRate: number;
	bloodPressureNumerator: number;
	bloodPressureDenominator: number;
	bloodPressureMinNumerator: number;
	bloodPressureMinDenominator: number;
	hasSa02Flatline: boolean;
	hasEtc02Flatline: boolean;
	hasHrFlatline: boolean;
	showETC02: boolean;
}

export default MonitorUI;